import { render, staticRenderFns } from "./ModalBase.vue?vue&type=template&id=35cd6277&scoped=true"
import script from "./ModalBase.vue?vue&type=script&lang=js"
export * from "./ModalBase.vue?vue&type=script&lang=js"
import style0 from "./ModalBase.vue?vue&type=style&index=0&id=35cd6277&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd6277",
  null
  
)

export default component.exports